module.exports = "<md-dialog flex=50> <md-dialog-content> <div class=md-dialog-content layout=row layout-align=\"start center\" layout-wrap style=background:#fff> <md-progress-circular md-mode=indeterminate></md-progress-circular> <p style=margin-bottom:0!important;padding-left:10px>{{infoMsg}}</p> </div> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/generic/views/loader.html
// module id = 476
// module chunks = 462